//angular
import { Injectable } from "@angular/core";
//others
import { Observable } from "rxjs";
import { AddressTypeValues, ChargeModelValues, ProductCategory, ProductRatePlanChargesCategory } from "src/app/app.data";
//app
import { RatePlanCharge } from "src/app/_shared/interfaces/subscription.interface";
import { Address, RestResponse, ShippingCalculateModel } from "src/app/_shared/models";
import { SharedGlobalService } from "./api/shared-global.service";

@Injectable()
export class ShippingService {

  constructor(
    private sharedGlobalService: SharedGlobalService,
  ) {}

  public calculateShipping(_items: Array<RatePlanCharge>, _address: Address, companyCurrencyId: number) {
    let bodyParams: ShippingCalculateModel = new ShippingCalculateModel();
    let weightTotal: number = 0;
    let orderAmount: number = 0;
    let itemsCount: number = 0;
    _items.forEach(_charge => {
      console.log('@@@_charge',_charge);
      if (_charge.category == ProductRatePlanChargesCategory.physical){
        if (!_charge.isFreeShipping) {
          weightTotal += Number(_charge.weight);
        }

        orderAmount += Number(_charge.amount);

        itemsCount += 1;
      }
    })

    bodyParams.city = _address?.city;
    bodyParams.country = _address?.country?.alpha2Code;
    bodyParams.state = _address?.state;
    bodyParams.residential = (_address?.type == AddressTypeValues.residential ? true : false);
    bodyParams.street1 = _address?.street1;
    bodyParams.street2 = _address?.street2;
    bodyParams.weight = weightTotal;
    bodyParams.zip = _address?.zip;
    bodyParams.itemCount = itemsCount;
    bodyParams.orderAmount = orderAmount;
    bodyParams.companyCurrencyId = companyCurrencyId;

    return new Observable(
      (observer) => {
      this.sharedGlobalService.calculateShipping(bodyParams)
        .subscribe(
          (res: any) => {
            observer.next(res);
          },
          (err: any) => {
            observer.error(err);
          }
        )
      }
    )
  }

  public getShippingRates(_companyIntegrationId:number, _serviceId:string, _items: Array<RatePlanCharge>, _address: Address) {
    let bodyParams: ShippingCalculateModel = new ShippingCalculateModel();
    let weightTotal: number = 0;

    _items.forEach(_charge => {
      if (_charge.category == ProductRatePlanChargesCategory.physical){
        weightTotal += _charge.weight;
      }
    })

    bodyParams.city = _address?.city;
    bodyParams.country = _address?.country?.alpha2Code;
    bodyParams.state = _address?.state;
    bodyParams.residential = (_address?.type == AddressTypeValues.residential ? true : false);
    bodyParams.street1 = _address?.street1;
    bodyParams.street2 = _address?.street2;
    bodyParams.weight = weightTotal;
    bodyParams.zip = _address?.zip;

    return new Observable(
      (observer) => {
      this.sharedGlobalService.createShippingByServiceId(_companyIntegrationId, _serviceId, bodyParams)
        .subscribe(
          (res: any) => {
            observer.next(res);
          },
          (err: any) => {
            observer.error(err);
          }
        )
      }
    )
  }

  public getShippingServices() {
    return new Observable(
      (observer) => {
      this.sharedGlobalService.getShippingServices()
        .subscribe(
          (res: RestResponse) => {
            observer.next(res);
          },
          (err: RestResponse) => {
            observer.error(err);
          }
        )
      }
    )
  }

  public getShipperHqServices(bodyParams: any) {
    return new Observable(
      (observer) => {
        this.sharedGlobalService.getShipperHQServices(bodyParams)
          .subscribe(
            (res: RestResponse) => {
              observer.next(res);
            },
            (err: RestResponse) => {
              observer.error(err);
            }
          )
      }
    )
  }
}
